// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Kgmx","colCheckbox":"styles_colCheckbox__346vU"};